import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import { cn } from '@/src/util/ui';

const Reply = (props) => {
  const { comment, className } = props;
  const enabledReply =
    props.isReplyingTo !== (comment.commentGroup ? comment.commentGroup : comment.id);

  const handleReply = () => {
    const replyTo = comment.commentGroup ? comment.commentGroup : comment.id;

    props.onReplying(replyTo);

    if (props.handleSelected) {
      props.handleSelected({
        id: comment.id,
        type: 'reply',
      });
    }
  };

  return (
    <Button
      className={cn(className, !enabledReply && 'active tw-font-brandonTextMedium')}
      onClick={handleReply}
    >
      Reply
    </Button>
  );
};
export default Reply;
